import { createClient } from 'contentful';

const spaceId = process.env.REACT_APP_CONTENTFUL_SPACE_ID;
const accessToken = process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN;



/**
 * Klient Contentful (Content Delivery API).
 * Użyj Delivery API token – jest read-only i bezpieczny w przeglądarce.
 */
export const contentfulClient =
  spaceId && accessToken
    ? createClient({
        space: spaceId,
        accessToken,
        environment: process.env.REACT_APP_CONTENTFUL_ENVIRONMENT || 'master',
      })
    : null;

/**
 * Pobiera listę wpisów (entries) z Contentful.
 * @param {Object} query - opcje zapytania (content_type, limit, order, locale, itp.)
 * @returns {Promise<Object>} - odpowiedź z items, total, itp.
 */
export async function getEntries(query = {}) {
  if (!contentfulClient) {
    throw new Error('Contentful client is not configured – brak danych dostępowych.');
  }
  return contentfulClient.getEntries(query);
}

/**
 * Pobiera pojedynczy wpis po ID.
 * @param {string} entryId - ID entry
 * @param {Object} query - opcje (np. locale)
 * @returns {Promise<Object>}
 */
export async function getEntry(entryId, query = {}) {
  if (!contentfulClient) {
    throw new Error('Contentful client is not configured – brak danych dostępowych.');
  }
  return contentfulClient.getEntry(entryId, query);
}

/**
 * Pobiera asset (obraz, plik) po ID.
 * @param {string} assetId - ID assetu
 * @returns {Promise<Object>}
 */
export async function getAsset(assetId) {
  if (!contentfulClient) {
    throw new Error('Contentful client is not configured – brak danych dostępowych.');
  }
  return contentfulClient.getAsset(assetId);
}

export default contentfulClient;
